(function () {
  function trim(str) {
    return (str || "").replace(/^\s+|\s+$/g, "");
  }

  function setReopenFlag() {
    try {
      sessionStorage.setItem("tf_reopen_cart_drawer", "1");
    } catch (e) {}
  }

  function isDrawerDiscount(el) {
    return !!el.closest("#CartDrawer, #CartNotification, cart-drawer, cart-notification");
  }

  function applyDiscount(code, fromDrawer) {
    var clean = trim(code);
    if (!clean) return;

    if (fromDrawer) {
      setReopenFlag();
    }

    var redirectTo = encodeURIComponent(
      window.location.pathname + window.location.search || "/"
    );

    var url =
      "/discount/" +
      encodeURIComponent(clean) +
      "?redirect=" +
      redirectTo;

    window.location.assign(url);
  }

  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest("[data-tf-apply-discount]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var root = btn.closest("[data-tf-discount]") || document;
      var input = root.querySelector('input[name="discount"]');

      if (!input) return;

      var code = trim(input.value);
      if (!code) return;

      applyDiscount(code, isDrawerDiscount(btn));
    },
    true
  );

  document.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Enter") return;

      var el = e.target;
      if (!el || el.name !== "discount") return;

      e.preventDefault();
      e.stopPropagation();

      var code = trim(el.value);
      if (!code) return;

      applyDiscount(code, isDrawerDiscount(el));
    },
    true
  );

  function reopenDrawerIfNeeded() {
    var shouldOpen = false;

    try {
      shouldOpen = sessionStorage.getItem("tf_reopen_cart_drawer") === "1";
      if (shouldOpen) {
        sessionStorage.removeItem("tf_reopen_cart_drawer");
      }
    } catch (e) {}

    if (!shouldOpen) return;

    var trigger =
      document.querySelector('[data-cart-drawer-open]') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector(".header__icon--cart");

    if (trigger) {
      trigger.click();
      return;
    }

    var drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector("cart-drawer");

    if (drawer) {
      drawer.setAttribute("open", "true");
      drawer.classList.add("modal--open");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reopenDrawerIfNeeded);
  } else {
    reopenDrawerIfNeeded();
  }
})();